import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { InventarioService } from '../inventario.service';
import { Etapa, EtapaContagemAgregado, EtapaEstrutura } from '../models/inventario';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-etapa-list',
  templateUrl: './etapa-list.component.html',
  styleUrls: ['./etapa-list.component.scss']
})
export class EtapaListComponent implements OnInit {

  public contagemAgregado: EtapaContagemAgregado[];
  public etapas: Etapa[];
  public etapa: Etapa ={} as Etapa;
  public idInventario: number;
  public idEtapa: number;
  public estrutura: EtapaEstrutura[];

  public submitted: boolean;
    public displayMsg: boolean = false;
    public displayDialog: boolean;


    public minDate: Date = new Date();

    cols: any[];

    tEst: TreeNode[];
    selectEst: any;
    pai: TreeNode;

  constructor(private inventarioService: InventarioService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private router: Router, 
    private activateRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.idInventario = parseInt(this.activateRoute.snapshot.paramMap.get("idInventario"));
    let etapas = this.activateRoute.snapshot.data['etapas'];
    this.etapas = etapas;
    console.log(this.etapas)

    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'size', header: 'Size' },
      { field: 'type', header: 'Type' }
  ];
  }

  getEtapas() {
    this.inventarioService.getEtapas(this.idInventario).subscribe(
      (res) => {
        if (res) {
          this.etapas = res;  
          console.log(this.etapas);
        }
      },
      err => {
        console.log("etapas");
        console.log(err);
      }
    );
  } 



  setChildren(pai: TreeNode,id, elPai:EtapaEstrutura){
    let estruturaFiltrada = this.estrutura.filter(x => x.idEstruturaMercadologicaPai==id);
    pai.children=[];
    if(estruturaFiltrada!=null && estruturaFiltrada.length>0){
      estruturaFiltrada.forEach(element => {
        let tmp: TreeNode = {} as TreeNode;
        tmp.label = element.nome;
        tmp.data = element.idEstruturaMercadologica;
        tmp.expandedIcon= "pi pi-folder-open";
        tmp.collapsedIcon= "pi pi-folder";
        if(element.flChecked){
          this.selectEst.push(tmp)
          if(!elPai.flChecked){
            pai.expanded=true;
          }

        }

        
        
        this.setChildren(tmp,element.idEstruturaMercadologica, element);
        if(tmp.expanded){
          pai.expanded=true;
        }
        pai.children.push(tmp);
      });
    }else{
      
    }
  }

  getEstruturaSelecionada(){
    this.etapa.estrutura=[];
    if(this.selectEst!=null && this.selectEst.length>0){
      this.selectEst.forEach(element => {
        if(element.data!=0 ){
          this.etapa.estrutura.push(element.data)
        }
        
      });
    }
    console.log(this.etapa.estrutura)
  }


  getEstrutura(idEtapa) {
    this.inventarioService.getEtapaEstrutura(idEtapa).subscribe(
      (res) => {
        if (res) {
          this.estrutura = res;  
          this.pai = {} as TreeNode;
          this.pai.label = 'COOPER';
          this.pai.data = '0';
          this.pai.expandedIcon= "pi pi-folder-open",
          this.pai.collapsedIcon= "pi pi-folder"
          this.pai.expanded=true;
          this.pai.children=[];
          this.tEst=[];
          this.selectEst=[];
            let estruturaFiltrada = this.estrutura.filter(x => x.nivel==1);
            estruturaFiltrada.forEach(element => {
              let tmp: TreeNode = {} as TreeNode;
              tmp.label = element.nome;
              tmp.data = 0;
              tmp.expandedIcon= "pi pi-folder-open",
              tmp.collapsedIcon= "pi pi-folder",
              this.setChildren(tmp,element.idEstruturaMercadologica,element)
              this.pai.children.push(tmp)
              
             

            });
            this.tEst.push(this.pai);
            console.log(this.selectEst)
            
          

          console.log(this.tEst)

         
         // console.log(this.estrutura);
          this.displayDialog = true;
        }
      },
      err => {
        this.messageService.add({severity: 'error', summary: 'Erro!', detail: 'Erro ao iniciar cadastro de Etapa -- Estrutura mercadologica!', life: 3000});
                  
        console.log("estrutura");
        console.log(err);
      }
    );
  } 

  
  addEtapa() {
    this.etapa = {} as Etapa;
    this.etapa.flAtivo=true;
    this.submitted = false;
    this.getEstrutura(0);
  } 
  
  updEtapa(etapa: Etapa) {      
    this.etapa = {...etapa};
    this.getEstrutura(this.etapa.idEtapa);
    this.etapa.dtCarga = new Date(etapa.dtCarga);
    this.etapa.dtFim = new Date(etapa.dtFim);
    console.log(this.etapa)
    this.displayDialog = true;
  }
  
  delEtapa(inventario: Etapa) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover a etapa: ' + inventario.dsEtapa + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.inventarioService
              .delEtapa(inventario.idEtapa)
              .subscribe(                     
                  () => {this.getEtapas()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Etapa removido com sucesso!', life: 3000});
                  },
                  err =>{
                    this.messageService.add({severity: 'error', summary: 'Erro!', detail: 'Etapa não pode ser removido, provavelmente existem contagens vinculadas!', life: 3000});
                  
                    console.log(err)
                  } 
              );
              
          }
      });
  }

  finalizarEtapa(inventario: Etapa) {
    this.confirmationService.confirm({
        message: 'Você tem certeza que deseja finalizar a etapa: ' + inventario.dsEtapa + '?',
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.inventarioService
            .finalizarEtapa(inventario.idEtapa)
            .subscribe(                     
                () => {this.getEtapas()
                  this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Etapa finalizada com sucesso!', life: 3000});
                },
                err =>{
                  this.messageService.add({severity: 'error', summary: 'Erro!', detail: 'Etapa não pode ser removido, provavelmente existem contagens vinculadas!', life: 3000});
                
                  console.log(err)
                } 
            );
            
        }
    });
}
  
  hideDialog() {
    this.etapa = {} as Etapa;
    this.submitted = false;
    this.displayDialog = false;        
  }


  saveEtapa(){
    this.submitted = true;      
    console.log(this.selectEst)
    console.log(this.tEst)
    this.etapa.idInventario = this.idInventario;
    this. getEstruturaSelecionada();
    if (this.etapa.dsEtapa) {
        if (this.etapa.idEtapa) {
          
          this.inventarioService
          .updEtapa(this.etapa)
          .subscribe(                     
              () => {
                this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Etapa atualizado com sucesso!', life: 3000});
                this.getEtapas()
              },
              err => console.log(err)
          );
           
        } else {
           this.inventarioService
               .addEtapa(this.etapa)
               .subscribe(                     
                   () =>{
                    this.getEtapas()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Etapa criado com sucesso!', life: 3000});
                   }, 
                   err => 
                   {
                      this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                     console.log(err)
                   }
               );

            
        }

        this.etapas = [...this.etapas];
        this.displayDialog = false;
        this.etapa = {} as Etapa;
    }
  }

  realizarCarga(etapa: Etapa) {
    this.confirmationService.confirm({
        message: 'Ao confirmar, os dados de produtos e estoques da etapa ' + etapa.dsEtapa + ' serão apagados e recarregados, os dados de contagem não serão perdidos, deseja continuar?',
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.inventarioService
            .realizarCarga(etapa.idEtapa)
            .subscribe(                     
                () => {
                  this.getEtapas()
                  this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Carga foi realizada com sucesso!', life: 3000});
                },
                err =>{
                  this.messageService.add({severity: 'error', summary: 'Erro!', detail: 'Erro ao realizar carga!', life: 3000});
                
                  console.log(err)
                } 
            );
            
        }
    });
  }


  getContagemAgregado(idEtapa) {
    this.inventarioService.getEtapaContagem(idEtapa).subscribe(
      (res) => {
        if (res) {
          this.contagemAgregado = res;  
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.contagemAgregado);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "contegem");
        });
        }
      },
      err => {
        console.log("contagemAgregado");
        console.log(err);
      }
    );
  } 

  getContagemUsuario(idEtapa) {
    this.inventarioService.getEtapaContagemUsuario(idEtapa).subscribe(
      (res) => {
        if (res) {
          let contagemUsuario = res;  
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(contagemUsuario);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "contagem_usuarios");
        });
        }
      },
      err => {
        console.log("contagemAgregado");
        console.log(err);
      }
    );
  } 


  exportExcel(idEtapa){
    this.getContagemAgregado(idEtapa);
  }
  exportContagemUsuarios(idEtapa){
    this.getContagemUsuario(idEtapa);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}

}
